import { render, staticRenderFns } from "./ModalProposeProduct.vue?vue&type=template&id=20b62742&scoped=true&"
import script from "./ModalProposeProduct.vue?vue&type=script&lang=js&"
export * from "./ModalProposeProduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalProposeProduct.vue?vue&type=style&index=0&id=20b62742&prod&lang=scss&"
import style1 from "./ModalProposeProduct.vue?vue&type=style&index=1&id=20b62742&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b62742",
  null
  
)

export default component.exports